import React from "react";
import { useLocation, Routes, Route } from "react-router-dom";

// Shared Layouts
import NavBars from "./Component/NavBars";
import Sidebar from "./Component/SideNavBar";

// Auth Pages
import Login from "./Component/Login";
import Signup from "./Component/SignUp";
import ResetPassword from "./Component/Resetpassword";

// =========================  using compoenets ============================================== //

// Main App Pages
import Home from "./Component/Homes";
import Bannerimages from "./Component/Bannerimages";
import SubscriptionsideNav from "./Component/Modules/Subscriptionmanagment/SubscriptionsideNav"
import Foodsubscription from "./Component/Modules/Subscriptionmanagment/Food/Foodsubscription";
import Grocerysubscription from "./Component/Modules/Subscriptionmanagment/Grocery/Grocerysubscription";
import Cateringsubscription from "./Component/Modules/Subscriptionmanagment/Catering/Cateringsubscription";
import Logisticssubscription from "./Component/Modules/Subscriptionmanagment/Logistics/Logisticssubscription";
import FoodClient from "./Component/Modules/Clientmanagment/Food/FoodClient";
import Cateringsidebar from "./Component/Modules/Clientmanagment/Cateringsidebar";
import Cateringclient from "./Component/Modules/Clientmanagment/Catering/Cateringclient";
import Cateringregisteterd from "./Component/Modules/Clientmanagment/Catering/Cateringregisteterd";
import Groceryclientmanagement from "./Component/Modules/Clientmanagment/Grocery/Groceryclientmanagement";
import Logisticsclients from "./Component/Modules/Clientmanagment/Logistics/Logisticsclients";
import Foodorder from "./Component/Modules/Ordermanagment/Food/Foodorder";
import Ordermanagmentsidebar from "./Component/Modules/Ordermanagment/Ordermanagmentsidebar";

import Cateringorders from "./Component/Modules/Ordermanagment/Catering/Cateringorders";
import Groceryorder from "./Component/Modules/Ordermanagment/Grocery/Groceryorder";
import Logisticsandservices from "./Component/Modules/Ordermanagment/Logistics/Logisticsandservices";
import Userdetails from "./Component/Modules/Usermanagment/Food/Userdetails";
import Usermanagmentsidebar from "./Component/Modules/Usermanagment/Usermanagmentsidebar";
import Userdetailsdata from "./Component/Modules/Usermanagment/Caterings/Userdetailsdata";

import Groceryuserdetails from "./Component/Modules/Usermanagment/Grocery/Groceryuserdetails";
import Logisticsuserdetails from "./Component/Modules/Usermanagment/Logistics/Logisticsuserdetails";
import Foodsetingspage from "./Component/Modules/Accounthistorymanagment/Food/Foodsetingspage";
import Accounthistorysidebar from "./Component/Modules/Accounthistorymanagment/Accounthistorysidebar";
import Cateringsetiingspage from "./Component/Modules/Accounthistorymanagment/Catering/Cateringsetiingspage";
import Groceriessettings from "./Component/Modules/Accounthistorymanagment/Grocery/Groceriessettings";
import Logisticssettings from "./Component/Modules/Accounthistorymanagment/Logistics/Logisticssettings";
import Foodaccounts from "./Component/Modules/Accountsandhistory/Food/Foodaccounts";
import Foodaccountsidebar from "./Component/Modules/Accountsandhistory/Foodaccountsidebar";
import CateringsAccounts from "./Component/Modules/Accountsandhistory/Caterings/CateringsAccounts";
import GroceryAccounts from "./Component/Modules/Accountsandhistory/Grocery/GroceryAccounts";
import LogisticsAccounts from "./Component/Modules/Accountsandhistory/Logistics/LogisticsAccounts";
import FoodPramotions from "./Component/Modules/Promotionsanddiscounts/Food/FoodPramotions";
import Promotionssidebar from "./Component/Modules/Promotionsanddiscounts/Promotionssidebar";
import Promotionscaterings from "./Component/Modules/Promotionsanddiscounts/Caterings/Promotionscaterings";
import Promotionsgrocery from "./Component/Modules/Promotionsanddiscounts/Grocery/Promotionsgrocery";
import Logisticspromotions from "./Component/Modules/Promotionsanddiscounts/Logistics/Logisticspromotions";
import Foodcare from "./Component/Modules/Customercaremanagment/Food/Foodcare";
import Coustomersidebar from "./Component/Modules/Customercaremanagment/Coustomersidebar";
import Foodreports from "./Component/Modules/ReportandAnalysis/Food/Foodreports";
import Logisticsreports from "./Component/Modules/ReportandAnalysis/Logistics/Logisticsreports";
import Reportsidebar from "./Component/Modules/ReportandAnalysis/Reportsidebar";
import CateringReports from "./Component/Modules/ReportandAnalysis/Caterings/CateringReports";
import Groceryreport from "./Component/Modules/ReportandAnalysis/Grocery/Groceryreport";
import Foodterms from "./Component/Modules/TermsAndConditions/Food/Foodterms";
import Termssidbar from "./Component/Modules/TermsAndConditions/Termssidbar";
import Cateringcare from "./Component/Modules/Customercaremanagment/Caterings/Cateringcare";
import Grocerycare from "./Component/Modules/Customercaremanagment/Grocery/Grocerycare";
import Logisticscare from "./Component/Modules/Customercaremanagment/Logistics/Logisticscare";
import Cateringterms from "./Component/Modules/TermsAndConditions/Caterings/Cateringterms";
import Grocerterm from "./Component/Modules/TermsAndConditions/Grocery/Grocerterm";
import Logisticsterms from "./Component/Modules/TermsAndConditions/Logistics/Logisticsterms";
import Controlmanagmentpage from "./Component/Modules/Controlmanagment/Controlpage/Controlmanagmentpage";
import Cateringmenu from "./Component/Modules/Menumanagment/Cateringsmenu/Cateringmenu";
import Controllmanagmentdata from "./Component/Modules/Controlmanagment/Controlpage/Controllmanagmentdata"
import Termsandconditions from "./Component/Termsandconditions";
import Controllmanagmentsuper from "./Component/Modules/Controlmanagment/Controlpage/Controllmanagmentsuper";
import ProtectedRoute from "./Component/ProtectedRoute";

const Layout = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Routes without any layout (like auth pages)
  const noLayoutRoutes = ["/", "/signup", "/resetpassword"];
  if (noLayoutRoutes.includes(path)) {
    return (
      <Routes>Userdetails
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
      </Routes>
    );
  }

  // Layout mapping based on path
  const layoutMap = [

    {
      paths: ["/foodsubscription", "/grocerysubscription", "/cateringsubscription", "/logisticssubscription"],
      Navbar: <NavBars />,
      Sidebar: <SubscriptionsideNav />
    },
    {
      paths: ["/foodclient", "/cateringclient", "/groceryclientmanagement", "/logisticsclients",],
      Navbar: <NavBars />,
      Sidebar: <Cateringsidebar />
    },
    {
      paths: ["/foodorder", "/cateringordersdata", "/groceryorder", "/logisticsandservices"],
      Navbar: <NavBars />,
      Sidebar: <Ordermanagmentsidebar />
    },

    {
      paths: ["/cateringuserdetailsdata", "/groceryuserdetails", "/logisticsuserdetails"],
      Navbar: <NavBars />,
      Sidebar: <Usermanagmentsidebar />
    },
    {
      paths: ["/foodsetingspage", "/cateringsetiingspage", "/groceriessettings", "/logisticssettings"],
      Navbar: <NavBars />,
      Sidebar: <Accounthistorysidebar />
    },
    {
      paths: ["/foodaccounts", "/cateringsaccounts", "/groceryaccounts", "/logisticsaccounts"],
      Navbar: <NavBars />,
      Sidebar: <Foodaccountsidebar />
    },
    {
      paths: ["/foodpramotions", "/promotionscaterings", "/promotionsgrocery", "/logisticspromotions"],
      Navbar: <NavBars />,
      Sidebar: <Promotionssidebar />
    },
    {
      paths: ["/foodcare", "/cateringcare", "/grocerycare", "/logisticscare"],
      Navbar: <NavBars />,
      Sidebar: <Coustomersidebar />
    },
    {
      paths: ["/foodreports", "/cateringreports", "/groceryreport", "/logisticsreports"],
      Navbar: <NavBars />,
      Sidebar: <Reportsidebar />
    },
    {
      paths: ["/foodterms", "/cateringterms", "/grocerterm", "/logisticsterms"],
      Navbar: <NavBars />,
      Sidebar: <Termssidbar />
    },

    {
      paths: ["/termsandconditionspage"],

    },

  ];

  const matchedLayout = layoutMap.find(layout =>
    layout.paths.includes(path)
  );

  const NavbarComponent = matchedLayout ? matchedLayout.Navbar : <NavBars />;
  const SidebarComponent = matchedLayout ? matchedLayout.Sidebar : <Sidebar />;

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {NavbarComponent}
      <div style={{ display: "flex", flexGrow: 1 }}>
        {SidebarComponent}
        <div style={{ flexGrow: 1, }}>
          <Routes>
            {/* Main App Routes */}
            <Route path="/homes" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/bannerimages" element={<ProtectedRoute><Bannerimages /></ProtectedRoute>} />

            {/* Business Routes */}
            {/* ====================================== All the Compoents ================================================================== */}

            <Route path="/foodsubscription" element={<ProtectedRoute><Foodsubscription /></ProtectedRoute>} />
            <Route path="/grocerysubscription" element={<ProtectedRoute><Grocerysubscription /></ProtectedRoute>} />
            <Route path="/cateringsubscription" element={<ProtectedRoute><Cateringsubscription /></ProtectedRoute>} />
            <Route path="/logisticssubscription" element={<ProtectedRoute><Logisticssubscription /></ProtectedRoute>} />
            <Route path="/foodclient" element={<ProtectedRoute><FoodClient /></ProtectedRoute>} />
            <Route path="/cateringclient" element={<ProtectedRoute><Cateringclient /></ProtectedRoute>} />
            <Route path="/cateringregisteterd" element={<ProtectedRoute><Cateringregisteterd /></ProtectedRoute>} />
            <Route path="/groceryclientmanagement" element={<ProtectedRoute><Groceryclientmanagement /></ProtectedRoute>} />
            <Route path="/logisticsclients" element={<ProtectedRoute><Logisticsclients /></ProtectedRoute>} />
            <Route path="/foodorder" element={<ProtectedRoute><Foodorder /></ProtectedRoute>} />
            <Route path="/cateringordersdata" element={<ProtectedRoute><Cateringorders /></ProtectedRoute>} />
            <Route path="/groceryorder" element={<ProtectedRoute><Groceryorder /></ProtectedRoute>} />
            <Route path="/logisticsandservices" element={<ProtectedRoute><Logisticsandservices /></ProtectedRoute>} />
            <Route path="/userdetails" element={<ProtectedRoute><Userdetails /></ProtectedRoute>} />
            <Route path="/cateringuserdetailsdata" element={<ProtectedRoute><Userdetailsdata /></ProtectedRoute>} />
            <Route path="/groceryuserdetails" element={<ProtectedRoute><Groceryuserdetails /></ProtectedRoute>} />
            <Route path="/logisticsuserdetails" element={<ProtectedRoute><Logisticsuserdetails /></ProtectedRoute>} />
            <Route path="/foodsetingspage" element={<ProtectedRoute><Foodsetingspage /></ProtectedRoute>} />
            {/* <Route path="/foodbillingandsetup" element={<Foodsetingspage />} /> */}
            <Route path="/cateringsetiingspage" element={<ProtectedRoute><Cateringsetiingspage /></ProtectedRoute>} />
            <Route path="/groceriessettings" element={<ProtectedRoute><Groceriessettings /></ProtectedRoute>} />
            <Route path="/logisticssettings" element={<ProtectedRoute><Logisticssettings /></ProtectedRoute>} />
            <Route path="/foodaccounts" element={<ProtectedRoute><Foodaccounts /></ProtectedRoute>} />
            <Route path="/cateringsaccounts" element={<ProtectedRoute><CateringsAccounts /></ProtectedRoute>} />
            <Route path="/groceryaccounts" element={<ProtectedRoute><GroceryAccounts /></ProtectedRoute>} />
            <Route path="/logisticsaccounts" element={<ProtectedRoute><LogisticsAccounts /></ProtectedRoute>} />
            <Route path="/foodpramotions" element={<ProtectedRoute><FoodPramotions /></ProtectedRoute>} />
            <Route path="/promotionscaterings" element={<ProtectedRoute><Promotionscaterings /></ProtectedRoute>} />
            <Route path="/promotionsgrocery" element={<ProtectedRoute><Promotionsgrocery /></ProtectedRoute>} />
            <Route path="/logisticspromotions" element={<ProtectedRoute><Logisticspromotions /></ProtectedRoute>} />
            <Route path="/foodcare" element={<ProtectedRoute><Foodcare /></ProtectedRoute>} />
            <Route path="/cateringcare" element={<ProtectedRoute><Cateringcare /></ProtectedRoute>} />
            <Route path="/grocerycare" element={<ProtectedRoute><Grocerycare /></ProtectedRoute>} />
            <Route path="/foodreports" element={<ProtectedRoute><Foodreports /></ProtectedRoute>} />
            <Route path="/foodterms" element={<ProtectedRoute><Foodterms /></ProtectedRoute>} />
            <Route path="/logisticscare" element={<ProtectedRoute><Logisticscare /></ProtectedRoute>} />
            <Route path="/cateringterms" element={<ProtectedRoute><Cateringterms /></ProtectedRoute>} />
            <Route path="/grocerterm" element={<ProtectedRoute><Grocerterm /></ProtectedRoute>} />
            <Route path="/logisticsterms" element={<ProtectedRoute><Logisticsterms /></ProtectedRoute>} />
            <Route path="/cateringreports" element={<ProtectedRoute><CateringReports /></ProtectedRoute>} />
            <Route path="/groceryreport" element={<ProtectedRoute><Groceryreport /></ProtectedRoute>} />
            <Route path="/logisticsreports" element={<ProtectedRoute><Logisticsreports /></ProtectedRoute>} />
            <Route path="/controlmanagmentpage" element={<ProtectedRoute><Controlmanagmentpage /></ProtectedRoute>} />
            <Route path="/cateringmenu" element={<ProtectedRoute><Cateringmenu /></ProtectedRoute>} />
            <Route path="/controllmanagmentdata" element={<ProtectedRoute><Controllmanagmentdata /></ProtectedRoute>} />
            <Route path="/termsandconditionspage" element={<ProtectedRoute><Termsandconditions /></ProtectedRoute>} />
            <Route path="/controllmanagmentsuper" element={<ProtectedRoute><Controllmanagmentsuper /></ProtectedRoute>} />



          </Routes>
        </div>
      </div>
    </div >
  );
};

export default Layout;
